import { apiClient } from "./client";

export const getProducts = ({ page = 1, limit = 10, search = "" } = {}) => {
  const query = new URLSearchParams({
    page: String(page),
    limit: String(limit)
  });

  if (search.trim()) {
    query.set("search", search.trim());
  }

  return apiClient.get(`/admin/products?${query.toString()}`);
};

export const getProductById = (productId) => {
  return apiClient.get(`/admin/products/${productId}`);
};

export const createProduct = (payload) => {
  return apiClient.post("/admin/products", payload);
};

export const updateProduct = (productId, payload) => {
  return apiClient.put(`/admin/products/${productId}`, payload);
};

export const deleteProduct = (productId) => {
  return apiClient.delete(`/admin/products/${productId}`);
};
